import styled from "styled-components";
import {CircularProgress, Button} from "@material-ui/core";

export const Enable2FAContent = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const Enable2FAContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ActionButton = styled(Button).attrs({
    variant: 'contained',
    color: 'primary'
})`
  white-space: nowrap;
  font-size: 1em;
  min-width: 150px !important;
  height: 50px;
  
  :hover {
    background-color: rgb(247, 247, 247);
  }
`;

export const Loader = styled(CircularProgress).attrs({
    size: '1.5rem',
    color: 'inherit'
})``;
